var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37769 20.6529C4.12669 19.5011 1 15.6157 1 11C1 5.47738 5.47691 0.999999 11 0.999999C16.5226 0.999999 21 5.47738 21 11C21 15.6621 17.8094 19.5792 13.493 20.687",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3051 14.0927C14.3051 14.0927 11.2603 16.9826 7.69507 14.0927",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.688 9.61479C15.1761 9.61479 15.5714 9.21968 15.5714 8.73136C15.5714 8.24247 15.1756 7.84697 14.688 7.84697C14.2005 7.84697 13.8041 8.24289 13.8041 8.73136C13.8041 9.21925 14.1999 9.61479 14.688 9.61479Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31164 9.61479C7.79977 9.61479 8.19508 9.21968 8.19508 8.73136C8.19508 8.24247 7.79921 7.84697 7.31164 7.84697C6.82413 7.84697 6.42773 8.24289 6.42773 8.73136C6.42773 9.21925 6.82356 9.61479 7.31164 9.61479Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaSmiley);
export default __webpack_public_path__ + "static/media/ha-smiley.b9b2b943c33c85326183c1761d4f706a.svg";
export { ForwardRef as ReactComponent };